export const INITIAL_ENROLL_NODE_ID = `enroll-${crypto.randomUUID()}`;

export const LAYOUT = {
  enrollWidth: 320,
  gapX: 40,
};
